import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production' 
  ? '/api'  // This will use the current domain (mrbrowncase.com) and be rewritten by Vercel
  : 'http://localhost:3001/api';

const api = axios.create({
  baseURL
});

// Add request interceptor to handle authorization
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;